'use client';
import dynamic from 'next/dynamic';
import { AttendantLayoutProps } from '../../editor/components/attendant-layout/attendant-layout.props';
import { LocationSearchPlaceholder } from '../../editor/components/location-search/location-search-placeholder';
import { useMemo } from 'react';

export const AttendantSearchContainer = ({
  searchParams,
  location,
  allowLocationChange,
  onlyMobile,
}: Pick<AttendantLayoutProps, 'searchParams' | 'location'> & {
  onlyMobile?: boolean;
  allowLocationChange?: boolean;
}) => {
  const AttendantSearch = useMemo(() => {
    return dynamic(() => import('./attendant-search'), {
      loading: () => (
        <LocationSearchPlaceholder
          onlyMobile={onlyMobile}
        ></LocationSearchPlaceholder>
      ),
      ssr: false,
    });
  }, [onlyMobile]);
  return (
    <AttendantSearch
      allowLocationChange={allowLocationChange}
      onlyMobile={onlyMobile}
      location={location}
      initSearchParams={searchParams}
    ></AttendantSearch>
  );
};
